export const GoogleLoginIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.14 12.2046C21.14 11.5664 21.0827 10.9527 20.9764 10.3636H12.5V13.845H17.3436C17.135 14.97 16.5009 15.9232 15.5477 16.5614V18.8196H18.4564C20.1582 17.2527 21.14 14.9455 21.14 12.2046V12.2046Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 21C14.93 21 16.9673 20.1941 18.4564 18.8196L15.5477 16.5614C14.7418 17.1014 13.7109 17.4205 12.5 17.4205C10.1559 17.4205 8.17182 15.8373 7.46409 13.71H4.45728V16.0418C5.93818 18.9832 8.98182 21 12.5 21V21Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.46409 13.71C7.28409 13.17 7.18182 12.5932 7.18182 12C7.18182 11.4068 7.28409 10.83 7.46409 10.29V7.95819H4.45727C3.84773 9.17319 3.5 10.5477 3.5 12C3.5 13.4523 3.84773 14.8268 4.45727 16.0418L7.46409 13.71V13.71Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 6.57955C13.8214 6.57955 15.0077 7.03364 15.9405 7.92545L18.5218 5.34409C16.9632 3.89182 14.9259 3 12.5 3C8.98182 3 5.93818 5.01682 4.45728 7.95818L7.46409 10.29C8.17182 8.16273 10.1559 6.57955 12.5 6.57955V6.57955Z"
      fill="#EA4335"
    />
  </svg>
);
